import { CanActivate, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { take, mergeMap, tap } from 'rxjs/operators';

import * as fromRoot from '../store';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private store: Store<fromRoot.State>,
  ) {}

  canActivate(): Observable<any> {
    return this.authService.isLoggined().pipe(
      mergeMap((isLoginned) => {
        if (isLoginned) {
          return of(true);
        }
        this.router.navigate(['/auth/login']);
        return of(false);
      }),
    );
  }
}
